module.exports = __webpack_public_path__ + "static/media/is.2ce20c50.svg";